/**
 * The slot registrations of `web/run` (2.E deliverable 8): the "Run" switch beside the page modes
 * of a session document (`header.modes.run`), empty while the `sessions` flag is off and on any
 * other document. `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/run']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { RunSwitch } from './run-switch.js';

export const owner: WorkPackageId = '2.E';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.modes', order: 10, owner: '2.E', component: RunSwitch },
];
